import {
  Box,
  Container,
  Stack,
  Typography,
  useTheme,
  SxProps,
} from '@mui/material'
import { useEffect } from 'react'
import { string, shape, oneOfType, node, bool } from 'prop-types'
import { useWindowWidth } from '~/utils/hooks/useSize'
import growthbook from '~/configs/growthBook'
import { useAuth } from '~/modules/auth/redux/hook'
import { useParams } from 'react-router-dom'
import { useUser } from '~/redux/hooks/user'
import { useActiveStore } from '~/redux/hooks/store'
import authApi from '~/modules/auth/services'

const SettingsLayout = ({
  children,
  title,
  action,
  systemLayout,
  sx,
}: {
  children: React.ReactNode
  title: React.ReactNode
  action: React.ReactNode
  systemLayout: boolean
  sx?: SxProps
}) => {
  const theme = useTheme()
  const { width } = useWindowWidth()
  const { storeId } = useParams()
  const { authState } = useAuth()
  const { orgId } = useUser()
  const activeStore = useActiveStore()
  const firebaseUserId = authApi.getUserFirebaseId()

  useEffect(() => {
    growthbook.setAttributes({
      id: authState?.data?.userId,
      email: authState?.data?.userEmail,
      role: authState?.data?.stores
        ? authState?.data?.stores[storeId]?.roleId
        : '',
      orgId,
      storeId,
      storeType: activeStore?.storeType,
      firebaseUserId: firebaseUserId || authState?.data?.userId,
    })
  }, [authState, orgId, storeId, activeStore?.storeType, firebaseUserId])

  return (
    <Box
      style={{
        minHeight: width > 1280 ? '100vh' : 'calc(100vh - 30px)',
        backgroundColor: theme.background.pageBg,
      }}
      className="customized-scrollbar"
      sx={sx}
    >
      <Container
        sx={{
          width: systemLayout ? '1200px' : '856px',
          maxWidth: '100%',
          padding: 2,
          '@media screen and (min-width: 600px)': {
            padding: 2,
          },
        }}
      >
        <Stack spacing={2}>
          <Box sx={{ display: 'flex' }}>
            {typeof title === 'string' ? (
              <Typography
                sx={{ ...theme.getTypoProperties(20) }}
                fontWeight="fontWeightBold"
                color={theme.foreground.black}
              >
                {title}
              </Typography>
            ) : (
              title
            )}
            {action && <Box ml="auto">{action}</Box>}
          </Box>
          {children}
        </Stack>
      </Container>
    </Box>
  )
}

SettingsLayout.defaultProps = {
  children: null,
  title: '',
  action: '',
  systemLayout: false,
  sx: {},
}

SettingsLayout.propTypes = {
  children: oneOfType([node, string]),
  title: oneOfType([string, node]),
  action: oneOfType([string, node, shape({})]),
  systemLayout: bool,
  sx: shape({}),
}

export default SettingsLayout
